import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "../styles/Winner.css"


const WinnerPage = () => {
  return (
    <div className="winner-page">
      <h1 className="winner-title">Thank You for Participating!</h1>

      <p className="winner-message">
        Thank you to everyone who took part in this year’s Neighborhood Holiday Lights Contest.
        Your creativity, enthusiasm, and dazzling displays helped make this season brighter
        for the entire Tamarac community.
      </p>

      <p className="winner-message">
        Stay tuned — we will be announcing the winners on the City of Tamarac’s social media
        channels on <strong>December 26</strong>. We can’t wait to celebrate the most festive
        homes of the year.
      </p>

      <p className="winner-footer">Happy Holidays from the City of Tamarac!</p>
    </div>
  );
};

export default WinnerPage;

